import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import AmazonRDSReaderForm from '../forms/amazon-rds-reader-form';
import { amazonRDSReaderFormSchema } from '../schema/amazonRDSReader.js';

export default function AmazonRDSReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Amazon RDS Reader Node Details',
        altText: 'Amazon RDS Reader Node',
        defaultLabel: 'RDS Reader Node',
      }}
    >
      <CommonNode FormComponent={AmazonRDSReaderForm} schemaResolver={amazonRDSReaderFormSchema} />
    </NodeProvider>
  );
}
